import {Component, Inject, LOCALE_ID} from '@angular/core';
import {LocalStorageService} from "library";
import {UserData} from "projects/store/src/app/interfaces";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-profile',
  templateUrl: './app.profile.component.html'
})
export class AppProfileComponent {
  userData: UserData;
  currentDate: Date = new Date();
  formattedDate: string = '';
  formattedTime: string = '';

  constructor(private localStorageService: LocalStorageService, private authService: AuthService, @Inject(LOCALE_ID) private locale: string) {
    this.userData = this.localStorageService.get(LocalStorageKey.data)
    this.updateTime();
  }

  updateTime() {
    const datePipe = new DatePipe(this.locale);

    setInterval(() => {
      this.currentDate = new Date();
      const rawDate = datePipe.transform(this.currentDate, 'MMMM d, y') || '';
      this.formattedDate = this.capitalize(rawDate);
      this.formattedTime = datePipe.transform(this.currentDate, 'h:mm a') || '';
    }, 1000);
  }

  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  gotoChangePassword() {
    this.authService.gotoSalesModule('cambio-clave');
  }

  gotoLogout() {
    this.authService.gotoSalesModule('auth/logout');
  }
}
